import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class CreditInvoiceReportData extends ReportData<CreditInvoiceReportData> {
    @field invoiceId: number;
}
